import axios from "axios";

export const  resetPassword = async (data) => {
    let result = await axios.get('resetPassword?tokenEmail='+data,)
    return result

}

export const  resetPasswordConfirm = async (email,token) => {
    let result = await axios.get('resetPassword?tokenEmail='+email+"&tokenReset="+token,)
    return result

}
export const  resetConfirm = async (data) => {
    let result = await axios.post('resetPassword',data)
    return result

}

export const  AuthConfirm = async (tokenEmail) => {
    let result = await axios.get('authConfirm?tokenEmail='+tokenEmail)
    return result

}
